<template>
  <section class="section container pt-0">
    <position-datatable />
  </section>
</template>

<script>
import PositionDatatable from "./position_datatable/Index.vue";
export default {
  name: "StaffPositions",
  components: {
    PositionDatatable,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
